import { useState, useEffect } from 'react';

const APP_VERSION = '2.0.0';
const STORAGE_KEY = `teachur_update_seen_v${APP_VERSION}`;

export const useAppUpdateModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      setIsOpen(true);
    }
  }, []);

  const onClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsOpen(false);
  };

  return { isOpen, onClose };
};
